var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-brand',{attrs:{"to":"/"}},[_vm._v(" Brands Admin ")])}
var staticRenderFns = []

export { render, staticRenderFns }